import request from 'sb-request'
import actions from 'redux/actions'
import { getCookieValue } from 'helpers'
import { reducers, getState } from 'redux/core'
import { constants } from 'common/helpers'


const selectItem    = reducers.view.makeupLandingPage.selectItem
const deselectItem  = reducers.view.makeupLandingPage.deselectItem

/**
 * Saves selected items to localStorage
 */
const saveSelectedItemsToStorage = () => {
  const { view: { makeupLandingPage: { selectedItems } } } = getState()

  actions.misc.localStorage.setItem(constants.localStorageNames.makeupLandingItems, selectedItems)
}

/**
 * Clear selected items from store and localStorage
 */
const clearSelectedItems = () => {
  actions.misc.localStorage.removeItem(constants.localStorageNames.makeupLandingItems)
  reducers.view.makeupLandingPage.clearSelectedItems()
}

/**
 * Clear selected items from makeup new style landing from store and localStorage
 */
const clearSelectedLandingItems = () => {
  actions.misc.localStorage.removeItem(constants.localStorageNames.makeupLandingNewStyleItems)
  reducers.view.makeupLandingPage.clearSelectedLandingItems()
}

const moveSelectedItemsFromCookieToStorage = () => {
  const selectedItems = (getCookieValue(constants.cookieNames.postponed.makeupLandingItems) || [])
    .filter((item) => {
      if (item && item.id) {
        return Boolean(item.id)
      }

      return false
    })

  if (selectedItems.length) {
    actions.misc.localStorage.setItem(constants.localStorageNames.makeupLandingItems, selectedItems)
    actions.misc.cookies.removeItem(constants.cookieNames.postponed.makeupLandingItems)
  }
}

const moveSelectedLandingItemsFromCookieToStorage = () => {
  const selectedLandingItems = (getCookieValue(constants.cookieNames.postponed.makeupLandingNewStyleItems) || [])
    .filter((item) => {
      if (item && item.id) {
        return Boolean(item.id)
      }

      return false
    })

  if (selectedLandingItems.length) {
    actions.misc.localStorage.setItem(constants.localStorageNames.makeupLandingNewStyleItems, selectedLandingItems)
    actions.misc.cookies.removeItem(constants.cookieNames.postponed.makeupLandingNewStyleItems)
  }
}

const setSelectedItemsFromStorage = () => {
  moveSelectedItemsFromCookieToStorage()
  moveSelectedLandingItemsFromCookieToStorage()

  const selectedItems         = actions.misc.localStorage.getItem(constants.localStorageNames.makeupLandingItems, [])
  const selectedLandingItems  = actions.misc.localStorage.getItem(constants.localStorageNames.makeupLandingNewStyleItems, [])

  reducers.view.makeupLandingPage.setSelectedItems(selectedItems)
  reducers.view.makeupLandingPage.setSelectedLandingItems(selectedLandingItems)
}

// todo @vkudla replace rest on graphql when added section param
const fetchProducts = () =>
  request.get('rest/shop/makeup?groupBy=section')
    .then(
      ({ items }) => {
        const itemsWithCategory = items.map((item) => ({
          ...item,
          category: item.section.replace('Makeup', '').toLowerCase(),
        }))

        const productsCount = itemsWithCategory.reduce((prev, curr) => [...prev, ...curr.items], []).length

        reducers.models.products.setProducts(itemsWithCategory)
        reducers.models.products.setProductCount(productsCount)
      })


export default {
  selectItem,
  deselectItem,
  setSelectedItemsFromStorage,
  saveSelectedItemsToStorage,
  clearSelectedItems,
  clearSelectedLandingItems,
  fetchProducts,
}
